import { createService, z } from '@bonanza-social/toolkit/api';
import {
  RawQuestSchema,
  InPeriodPromosResponseSchema,
} from './QuestsService.schemas';

export default createService(
  {
    getQuests: {
      method: 'GET',
      url: '/inPeriodPromotions',
      headers: {
        'X-Feature-EnableTokenRewards': 'true',
      },
      responseSchema: InPeriodPromosResponseSchema,
      headers: {
        'X-Feature-EnableMetaGameRewards': 'true',
      },
    },
    getQuest: {
      method: 'GET',
      url: ({ promoId }: { promoId: number }) => `/promotions/${promoId}`,
      responseSchema: RawQuestSchema,
    },
    getUserPromoOptinUrl: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) => `/promotions/${promoId}/optin`,
      responseSchema: z.object({}).optional(),
    },
    getUserPromoOptoutUrl: {
      method: 'POST',
      url: ({ promoId }: { promoId: number }) =>
        `/promotions/${promoId}/optout`,
      responseSchema: z.object({}).optional(),
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
